import { ShortCode } from '@highereducation/wordpress';
import { StickyColumn, type StickyColumnProps } from '@highereducation/hen-ui';

type StickyColumnShortcodeProps = {
  heading: string;
  description: string;
  /**
   * Semantic + visual level for the sticky heading: `h1` | `h2` | … | `h6`.
   * Defaults to `h1`. Set to `h2` when the page already has an `h1` (e.g. a
   * hero) so the document outline stays valid.
   */
  'heading-level'?: StickyColumnProps['headingLevel'];
  children?: React.ReactNode;
};

export const StickyColumnShortcode: ShortCode<StickyColumnShortcodeProps> = {
  component: ({
    heading,
    description,
    'heading-level': headingLevel,
    children,
  }) => {
    return (
      <StickyColumn
        heading={heading}
        description={description}
        headingLevel={headingLevel}
      >
        {children}
      </StickyColumn>
    );
  },
};
